import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";

const About = () => (
  <StyledAbout>
    <Container>
      <UnderlinedHeader text={"About us"} bolder />
      <p>
        Pedders Suspension is Australia's No1 suspension and steering parts
        manufacturer that has played a prominent role in the Australian
        automotive aftermarket industry for over 65 years. Commenced in 1950 as
        Pedders Die Cast Welding Service by Roy Pedder, the business found his
        niche in the automotive market in repairing old type lever arm shock
        absorbers. By the late 1950’s the business had 13 staff repairing over
        3000 shock absorbers per month. In 1972, Roy’s eldest son Ron Pedder,
        took over the company. Around this time Ron took the next significant
        step and utilising what the company had learnt from repairing &
        reconditioning shock absorbers and began designing and ultimately
        manufacturing its own. He also opened Pedders first Pedders stores to
        install the parts he designed and had manufactured. This lead to many
        more new stores via Pedders Store franchising.
      </p>
      <p>
        Pedders is now headed up by Ron’s eldest son Mark Pedder who took on the
        role as Managing Director in 2006. This large, multinational automotive
        company has come a long way from a suburban Melbourne welding shop, and
        most if not all of this growth has been due to the determination,
        dedication and foresight of our most important asset - our people. Today
        Pedders has over 120 stores throughout Australia serviced by 5
        distribution centres.
      </p>
      <p>
        Since commencing international sales into the UK & USA in 2006, today
        Pedders has company warehouses in the UK, Poland, UAE, Thailand,
        Indonesia, China, Malaysia, Sth Africa & the USA.
      </p>
      <p>
        For each new chassis, Pedders develops an integrated and engineered
        suspension solution. Be it OEM quality replacement parts, performance
        parts for passenger cars or tough off-road suspension we are one of the
        few manufacturers with a holistic solution. Whilst Pedders commenced as
        a shock absorber company, today we are unique in that we offer a
        “system” that we design, manufacture, distribute and in Australia also
        install all under the Pedders brand. Our “matched” parts include shock
        absorbers, springs (coil, leaf & torsion bar), bushings (polyurethane &
        rubber), chassis parts, hardware (camber pins, bump stops, sway bar
        components, mounts etc.), control arms, trailing arms, power steering
        gears & pumps, CV joints & shafts and even brake parts including pads,
        rotors & drums. All Pedders Branded – a SYSTEM.
      </p>
      <p>
        We started in Europe with replacement shocks for Subaru Forester. Next
        the Nissan X Trail. Then Nissan Patrol, VW Golf, Toyota Landcruiser,
        Mitsubishi Pajero, Isuzu D-Max, VW Amarok and Ford Ranger. Then we moved
        to more makes and models. The results with the vehicles we produce parts
        for have been amazing. We upgrade everything to make certain that we are
        testing at or above the levels of performance our customers will reach.
        We document every step of our development in enthusiast forums so they
        can benefit from our hard work.
      </p>
      <p>
        Ride quality is subjective. Our test cars serve as daily drivers. As we
        do our R&D work in Australia and in Europe, the goal is to achieve a
        “Pedders feel”: the ideal balance between civility and performance
        handling.
      </p>
      <p>
        Our rapid growth in the European market is backed by our commitment to
        the customer. We welcome feedback as it makes us better. Our product
        solutions are driven by you and your driving needs. We are passionate
        about our product, our people and most importantly our customers. When
        we think about Pedders Europe, we think about you and your vehicle
        needs. We handcraft solutions for our customers. Making the experience
        better. Everything we do is driven by you!
      </p>
      <p>
        The website Pedders.eu is run by the Pedders' official stockist and
        distributor for Europe - OZPARTS PL sp. z o.o. based on a long
        association with Pedders Shock Absorber Service Pty Ltd.
      </p>
    </Container>
  </StyledAbout>
);

export default About;

const StyledAbout = styled.section`
  padding-top: 92px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
`;
